export const DUMMY_MUTATION = 'DUMMY_MUTATION';

export const CORDOVA_DEVICEREADY = 'CORDOVA_DEVICEREADY';
export const CORDOVA_ONLINE = 'CORDOVA_ONLINE';
export const CORDOVA_OFFLINE = 'CORDOVA_OFFLINE';
export const CORDOVA_SET_DEVICE = 'CORDOVA_SET_DEVICE';
export const CORDOVA_DEVICE_REGISTER = 'CORDOVA_DEVICE_REGISTER';
export const CORDOVA_NEW_NOTIFICATION = 'CORDOVA_NEW_NOTIFICATION';

export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const AUTH_SET_USER = 'AUTH_SET_USER';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_FIRST_TIME = 'AUTH_FIRST_TIME';

export const TRIPS_SET_CURRENT = 'TRIPS_SET_CURRENT';
export const TRIPS_CURRENT_REMOVE_PASSENGER_BY_ID =
    'TRIPS_CURRENT_REMOVE_PASSENGER_BY_ID';
export const TRIPS_SET_TRIPS = 'TRIPS_SET_TRIPS';
export const TRIPS_ADD_TRIPS = 'TRIPS_ADD_TRIPS';
export const TRIPS_RESTORE_PAGE = 'TRIPS_RESTORE_PAGE';
export const TRIPS_SET_SEARCH_FILTER = 'TRIPS_SET_SEARCH_FILTER';
export const TRIPS_SET_LAST_PAGE = 'TRIPS_SET_LAST_PAGE';
export const TRIPS_UPDATE_TRIPS = 'TRIPS_UPDATE_TRIPS';
export const TRIPS_NEXT_PAGE = 'TRIPS_NEXT_PAGE';
export const TRIPS_SET_REQUEST = 'TRIPS_SET_REQUEST';
export const TRIPS_ADD_PASSENGER = 'TRIPS_ADD_PASSENGER';
export const TRIPS_REMOVE_PASSENGER = 'TRIPS_REMOVE_PASSENGER';
export const TRIPS_REFRESH = 'TRIPS_REFRESH';
export const TRIPS_SET_SCROLL = 'TRIPS_SETSCROLL';

export const MYTRIPS_SET_DRIVER_TRIPS = 'MYTRIPS_SET_DRIVER_TRIPS';
export const MYTRIPS_SET_PASSENGER_TRIPS = 'MYTRIPS_SET_PASSENGER_TRIPS';
export const MYTRIPS_ADD_TRIPS = 'MYTRIPS_ADD_TRIPS';
export const MYTRIPS_UPDATE_TRIPS = 'MYTRIPS_UPDATE_TRIPS';
export const MYTRIPS_DELETE_TRIPS = 'MYTRIPS_DELETE_TRIPS';
export const MYTRIPS_SET_PENDING_RATES = 'MYTRIPS_SET_PENDING_RATES';
export const MYTRIPS_ADD_PASSENGER = 'MYTRIPS_ADD_PASSENGER';
export const MYTRIPS_REMOVE_PASSENGER = 'MYTRIPS_REMOVE_PASSENGER';
export const MYTRIPS_REMOVE_PASSENGER_TRIP = 'MYTRIPS_REMOVE_PASSENGER_TRIP';
export const MYTRIPS_SET_DRIVER_TRIPS_OLD = 'MYTRIPS_SET_DRIVER_TRIPS_OLD';
export const MYTRIPS_SET_PASSENGER_TRIPS_OLD =
    'MYTRIPS_SET_PASSENGER_TRIPS_OLD';

export const USERTRIPS_SET_DRIVER_TRIPS = 'USERTRIPS_SET_DRIVER_TRIPS';
export const USERTRIPS_SET_PASSENGER_TRIPS = 'USERTRIPS_SET_PASSENGER_TRIPS';
export const USERTRIPS_SET_USER = 'USERTRIPS_SET_USER';

export const DEVICE_SET_CURRENT_DEVICE = 'DEVICE_SET_CURRENT_DEVICE';
export const DEVICE_SET_DEVICES = 'DEVICE_SET_DEVICES';
export const DEVICE_DELETE = 'DEVICE_DELETE';
export const DEVICE_SET_FIRST_TIME_APP_OPEN = 'DEVICE_SET_FIRST_TIME_APP_OPEN';

export const CONVERSATION_SET_LIST = 'CONVERSATION_SET_LIST';
export const CONVERSATION_SET_USERLIST = 'CONVERSATION_SET_USERLIST';
export const CONVERSATION_SET_SELECTED = 'CONVERSATION_SET_SELECTED';
export const CONVERSATION_ADD_MESSAGE = 'CONVERSATION_ADD_MESSAGE';
export const CONVERSATION_INSERT_MESSAGE = 'CONVERSATION_INSERT_MESSAGE';
export const CONVERSATION_SET_LAST_PAGE = 'CONVERSATION_SET_LAST_PAGE';
export const CONVERSATION_BLANK_MESSAGES = 'CONVERSATION_BLANK_MESSAGES';
export const CONVERSATION_SET_TIMESTAMP = 'CONVERSATION_SET_TIMESTAMP';
export const CONVERSATION_CREATE_MESSAGES = 'CONVERSATION_CREATE_MESSAGES';
export const CONVERSATION_UPDATE = 'CONVERSATION_UPDATE';
export const CONVERSATION_PUSH = 'CONVERSATION_PUSH';
export const CONVERSATION_GET = 'CONVERSATION_GET';
export const CONVERSATION_SET_CONVERSATION = 'CONVERSATION_SET_CONVERSATION';

export const CARS_SET = 'CARS_SET';
export const CARS_ADD = 'CARS_ADD';
export const CARS_UPDATE = 'CARS_UPDATE';
export const CARS_DELETE = 'CARS_DELETE';

export const SUBSCRIPTION_SET = 'SUBSCRIPTION_SET';
export const SUBSCRIPTION_ADD = 'SUBSCRIPTION_ADD';
export const SUBSCRIPTION_UPDATE = 'SUBSCRIPTION_UPDATE';
export const SUBSCRIPTION_DELETE = 'SUBSCRIPTION_DELETE';

export const FRIENDS_SET_PENDING = 'FRIENDS_SET_PENDING';
export const FRIENDS_REMOVE_PENDING = 'FRIENDS_REMOVE_PENDING';
export const FRIENDS_REMOVE = 'FRIENDS_REMOVE';
export const FRIENDS_SET_USERS = 'FRIENDS_SET_USERS';
export const FRIENDS_SET_REQUEST = 'FRIENDS_SET_REQUEST';
export const FRIENDS_SET_SEARCHING = 'FRIENDS_SET_SEARCHING';

export const PASSENGER_SET_PENDING = 'PASSENGER_SET_PENDING';
export const PASSENGER_SET_PENDING_PAYMENT = 'PASSENGER_SET_PENDING_PAYMENT';
export const PASSENGER_REMOVE_PENDING = 'PASSENGER_REMOVE_PENDING';

export const NOTIFICATIONS_SET = 'NOTIFICATIONS_SET';
export const NOTIFICATIONS_COUNT = 'NOTIFICATIONS_COUNT';
export const NOTIFICATIONS_DELETE = 'NOTIFICATIONS_DELETE';

export const RATES_SET = 'RATES_SET';
export const RATES_REMOVE = 'RATES_REMOVE';

export const HEADER_SET_TITLE = 'HEADER_SET_TITLE';
export const HEADER_SET_TITLE_LINK = 'HEADER_SET_TITLE_LINK';
export const HEADER_SET_SUB_TITLE = 'HEADER_SET_SUB_TITLE';
export const HEADER_SET_IMG_TITLE = 'HEADER_SET_IMG_TITLE';
export const HEADER_SET_VISIBILITY = 'HEADER_SET_VISIBILITY';
export const HEADER_LOGO_SET_VISIBILITY = 'HEADER_LOGO_SET_VISIBILITY';
export const FOOTER_SET_VISIBILITY = 'FOOTER_SET_VISIBILITY';
export const FOOTER_SET_ACTIVE = 'FOOTER_SET_ACTIVE';

export const PROFILE_SET_USER = 'PROFILE_SET_USER';
export const PROFILE_SET_REPLY = 'PROFILE_SET_REPLY';
export const PROFILE_SAVE_REGISTER_DATA = 'PROFILE_SAVE_REGISTER_DATA';
export const PROFILE_CLEAN_REGISTER_DATA = 'PROFILE_CLEAN_REGISTER_DATA';
export const PROFILE_REFERENCE_ADD = 'PROFILE_REFERENCE_ADD';
export const PROFILE_SET_BADGES = 'PROFILE_SET_BADGES';
export const DONATION_INTENT_PUSH = 'DONATION_INTENT_PUSH';

export const BACKGROUND_SET_STYLE = 'BACKGROUND_SET_STYLE';
